export default __webpack_public_path__ + "static/damilola-e716f07c9fd276acbb8692dd3de8afe3.png";